import { render, staticRenderFns } from "./DefaultContent-Products.vue?vue&type=template&id=ab27784a&"
import script from "./DefaultContent-Products.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-Products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports